import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Authenticate } from "sprout-ui-dom/dist/Authenticate";
import { useCallback, useEffect, useState } from "react";
import useToggle from "@sprout/hooks/dist/useToggle";
import { useBus } from "sprout-ui-dom/dist/Bus";
import styled from "styled-components";
import { themeGet } from "sprout-ui-theme";
import { Box } from "sprout-ui-primitives";
import { CSSTransitionPortal } from "sprout-ui-dom/dist/Portal";
import { Close } from "sprout-ui-icons";
import { Button } from "sprout-ui-dom/dist/Button";
import { addClass, hasClass, removeClass } from "dom-helpers";
import { DialogRoot } from "./styles";
const dialogTimeout = {
    enter: 0,
    exit: 0
};
const handleEnter = ()=>{
    if (hasClass(document.body, "overlay")) return;
    addClass(document.body, "overlay");
};
const handleExited = ()=>{
    removeClass(document.body, "overlay");
};
const StyledBox = styled(Box)`
  position: relative;
  box-shadow: 0 1px 20px ${themeGet("colors.black.10")};
`;
const AuthenticationDialogRoot = styled(DialogRoot)`
  background: ${themeGet("colors.white.95")};
  pointer-events: auto;
`;
const CloseButton = styled(Button)`
  position: absolute;
  top: 12px;
  right: 12px;
`;
const AuthenticationDialog = ()=>{
    const [open, setOpen, setClose] = useToggle();
    const [variant, setVariant] = useState("signup");
    const eventBus = useBus();
    useEffect(()=>{
        eventBus.on("dialog::auth::open", (isSignUp)=>{
            if (isSignUp === false) setVariant("signin");
            if (isSignUp === undefined) setVariant("signup");
            setOpen();
        });
    }, [
        eventBus,
        setOpen
    ]);
    const onCalloutClick = useCallback(()=>{
        setVariant((currentVariant)=>{
            return currentVariant === "signin" ? "signup" : "signin";
        });
    }, []);
    const handleClick = useCallback((event)=>{
        if (event.target.tagName === "A") setClose();
    }, [
        setClose
    ]);
    return /*#__PURE__*/ _jsx(CSSTransitionPortal, {
        open: open,
        timeout: dialogTimeout,
        onEnter: handleEnter,
        onExited: handleExited,
        children: /*#__PURE__*/ _jsx(AuthenticationDialogRoot, {
            children: /*#__PURE__*/ _jsxs(StyledBox, {
                onClick: handleClick,
                borderRadius: "30px",
                bg: "white.100",
                maxWidth: "680px",
                width: "100%",
                m: "auto",
                py: "96px",
                children: [
                    /*#__PURE__*/ _jsx(CloseButton, {
                        variant: "circle",
                        onClick: setClose,
                        children: /*#__PURE__*/ _jsx(Close, {})
                    }),
                    /*#__PURE__*/ _jsx(Authenticate, {
                        variant: variant,
                        onCalloutClick: onCalloutClick
                    })
                ]
            })
        })
    });
};
export default AuthenticationDialog;
